module.exports = __webpack_public_path__ + "static/media/skincarepro_v1_2landing.410d5b53.png";